module.exports = __webpack_public_path__ + "static/img/photo.2a9ed447.png";